import * as React from 'react'
import Auth from 'shared/views/Auth/Auth'
import Loader from 'shared/views/Auth/Loader'
import Oops from './Oops/Oops'
import signinRedirectCallback from '../shared/views/Auth/signinRedirectCallback'
import silentRenew from '../shared/views/Auth/silentRenew'
import { AuthContext } from 'context/authContext'
import { CleanStorage } from 'apps/Panel/views/CleanStorage/CleanStorage'
import { Redirect, Route, Switch } from 'react-router-dom'

const Onboarding = React.lazy(() => import('./Onboarding/Onboarding'))
const Panel = React.lazy(() => import('./Panel/Panel'))

const Index = () => (
  <React.Suspense fallback={<Loader />}>
    <Switch>
      <Route path='/auth' component={Auth} />
      <Route path='/cleanStorage' component={CleanStorage} />
      <Route path='/signin-oidc' component={signinRedirectCallback} />
      <Route path='/redirect-silentrenew' component={silentRenew} />
      <Route path='/oops' component={Oops} />
      <RoutePrivate path='/onboarding' component={Onboarding} />
      <RoutePrivate path='/' component={Panel} />
    </Switch>
  </React.Suspense>
)

const RoutePrivate = ({ component: Component, ...rest }: any) => {
  const { authService } = React.useContext(AuthContext)
  return (
    <Route
      {...rest}
      render={props =>
        authService.isAuthenticated() ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: '/auth', state: { from: props.location } }} />
        )
      }
    />
  )
}

export default Index
